import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { JsonConvert } from 'json2typescript';
import { Observable } from 'rxjs';

import { CustomerInformationResponse } from '@features/succession/interfaces';
import { CustomerInformation } from '@features/succession/models';

@Injectable({ providedIn: 'root' })
export class CustomerInformationService {
  private readonly httpClient = inject(HttpClient);

  private readonly jsonConvert = inject(JsonConvert);

  public saveAndLoad(
    customerInformation: CustomerInformation,
  ): Observable<CustomerInformationResponse> {
    return this.httpClient.post<CustomerInformationResponse>(
      '/rgg/inheritances/v1/inheritances/selfcare-form',
      {
        selfCareForm: this.jsonConvert.serialize(customerInformation, CustomerInformation),
      },
    );
  }
}
